define(
({
  "select_shipping_method": "Gönderim Yöntemini Seç"
})
);
